import React from 'react';

import { Field } from '@tmap/mmm-style-guide/src/final-form/react';
import { Avatar } from '@tmap/mmm-style-guide/src/Avatar';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { AddAPhoto } from '@tmap/mmm-style-guide/src/Icon';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';

import FileInputField from '@tmap/mmm-style-guide/src/fields/FileInputField';
import TextFieldField from '@tmap/mmm-style-guide/src/fields/TextFieldField';

import ProfileAvatar from '../../profileAvatar';

const UploadButtonContainer = styled('div')(({ theme }) => ({
  background: theme.palette.grey[100],
  border: `1px dashed ${theme.palette.grey[400]}`,
  borderRadius: '127px',
  display: 'flex',
  alignItems: 'center',
  height: '64px',
  width: '64px',
  color: theme.palette.text.secondary,
}));

function ProfileInputs({ userImage, uploadedImage }) {
  const profilePreview = uploadedImage
    ? URL.createObjectURL(uploadedImage)
    : null;
  let imageFieldContent;
  if (uploadedImage) {
    imageFieldContent = (
      <Avatar sx={{ height: '60px', width: '60px' }}>
        <img src={profilePreview} alt='profile' style={{ height: '60px', width: '60px' }} />
      </Avatar>
    );
  } else if (userImage) {
    imageFieldContent = (<ProfileAvatar size={60} />);
  } else {
    imageFieldContent = (
      <UploadButtonContainer>
        <AddAPhoto sx={{ margin: '0 auto' }} />
      </UploadButtonContainer>
    );
  }
  return (
    <>
      <Typography variant='subtitle1' fontWeight={500} marginTop={6.5}>Your Name and Photo</Typography>
      <Box sx={{ mt: 2.5, display: 'flex', alignItems: 'center' }}>
        <Field name='profileImage' accept='image/*' component={FileInputField}>
          {imageFieldContent}
        </Field>
        <Typography fontSize='12px' sx={{ ml: 1.5, color: (theme) => theme.palette.text.disabled }}>
          Profile photo optional, but encouraged
        </Typography>
      </Box>
      <Grid container spacing={3} marginTop={1}>
        <Grid item xs={12} sm={6}>
          <Field
            name='firstName'
            component={TextFieldField}
            label='First Name'
            fullWidth
            validate={(value) => (value ? undefined : 'First name is required.')}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            name='lastName'
            component={TextFieldField}
            label='Last Name'
            fullWidth
            validate={(value) => (value ? undefined : 'Last name is required.')}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default ProfileInputs;
